import { apiClient } from "@/lib/api-client"
import type {
  CreateSocialPostRequest,
  FacebookPageInfo,
  SocialPost,
} from "../types/social-publish.types"

export async function createSocialPost(
  data: CreateSocialPostRequest,
  idempotencyKey: string,
): Promise<SocialPost> {
  const response = await apiClient.post<{
    success: boolean
    data: SocialPost
    message: string
  }>("/api/social/posts", data, {
    headers: { "Idempotency-Key": idempotencyKey },
  })
  return response.data.data
}

export async function getSocialPostStatus(postId: string): Promise<SocialPost> {
  const response = await apiClient.get<{
    success: boolean
    data: SocialPost
    message: string
  }>(`/api/social/posts/${postId}`)
  return response.data.data
}

export async function getFacebookPages(): Promise<FacebookPageInfo[]> {
  const response = await apiClient.get<{
    success: boolean
    data: { pages: FacebookPageInfo[] }
    message: string
  }>("/api/social/accounts/facebook/pages")
  return response.data.data.pages
}
